var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextInput',{attrs:{"title":'会社名',"originalValue":_vm.originalValue,"placeholder":'例）ジンジ株式会社',"maxLength":80},on:{"on-input":function($event){return _vm.$emit('on-input', $event.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }